import { render } from "./OrderHistory.vue?vue&type=template&id=b857839c&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b857839c"

export default script